<template>
    <a :href="generateUrl(detailAction, data)"
            class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
        <i class="pi pi-search"></i>
    </a>
    <a v-if="categoryAction" :href="generateUrl(categoryAction)"
            class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
        <i class="pi pi-list"></i>
    </a>
</template>
  
  <script>
  


  
  export default {
    name: "SearchActionButtons",
    components: {},
    props: ['detailAction', 'categoryAction', "data"],
    data() {
      return {};
    },
    methods: {
        generateUrl(action, params) {
            return route(action, params);
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>